import "styled-components";

const springTheme = {
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/tree-buds.png") no-repeat bottom center,
    radial-gradient(circle, #9ab5bc, #557c87)`,
  },
  header: {
    fontColor: "#ebe3d8",
    // background: "#3f666a",
    background: `linear-gradient(to right, transparent, rgba(60,99,110, 0.9), transparent)`,
  },
  footer: {
    fontColor: "#decebe",
  },
  switcher: {
    background: `linear-gradient(to right, transparent, rgba(226, 182, 167, 0.7), transparent)`,
    headerBackgroundColor: "#557c87",
    bodyBackgroundColor: "#9ab5bc",
    hoverColor: "#eac4c2",
    fontColor: "#ebe3d8",
    buttonFontColor: "#decebe",
  },
  calendar: {
    backgroundColors: {
      emptyCell: "#dec8b9",
      mainCell: "#fbe9db",
      dayOfWeekCell: "#fbe9db",
    },
    fontColors: {
      main: "#9f8a6f",
      empty: "#c0bdb9",
      day: "#6f604d",
      sunday: "#d58985",
    },
  },
};

// #9aadb5

export default springTheme;
